import { isSSRMode } from '@/utils/utils';
import errorHandlerService from '@/services/error-handler.service';
import { Faq, FaqType, IFaqItems, IFaqResponse } from '@/api/faq';
import { useHydratedPromise, CacheTime } from '@ans/useHydratePromise';
import { TAMAGO_VERSION } from '@/utils/constants/httpGlobals';
import { useRepositoryProperties } from '@/hooks/useRepositoryProperties';
const remapFaq = (faq: IFaqResponse) => {
    const faqItems = faq.items.map((item, index) => {
        const faqNodeItems = item.items.map((itemNode, nodeIndex) => ({
            ...itemNode,
            id: Number((index + 1).toString().concat(nodeIndex.toString())),
        }));

        return {
            ...item,
            items: [...faqNodeItems],
        };
    });

    return {
        items: faqItems as unknown as IFaqItems[],
    };
};

export const useFAQApi = (type?: FaqType) => {
    const { http, config, dispatch, navigate, prepareUuid } = useRepositoryProperties();
    const { value, ...state } = useHydratedPromise({
        fn: async () => {
            const response = await Faq.getContent(http, type);

            return remapFaq(response);
        },
        uuid: prepareUuid(`faq-${type}`),
        appName: config.APP_NAME,
        apiVersion: TAMAGO_VERSION,
        isSsrMode: isSSRMode(),
        cache: {
            policy: 'client-and-server',
            expireInSeconds: CacheTime.toSeconds.minutes(15),
        },
        onError: err => {
            errorHandlerService.dispatchErrorAction(config.LOCALE, dispatch, window.history, undefined, navigate)(err);
        },
    });

    return {
        ...state,
        value: value || {
            items: [],
        },
    };
};
